import React from 'react'
import PropTypes from 'prop-types'
import Chart from 'chart.js'

export default class ChartComponent extends React.Component {
    constructor(props) {
        super(props)
        this.canvasRef = React.createRef()
    }
    static propTypes = {
        type: PropTypes.string,
        labels: PropTypes.array,
        dataSets: PropTypes.array,
    }

    shouldComponentUpdate = nextProps => {
        const { labels } = this.props
        const isLabelDifferent = labels.length !== nextProps.labels.length
        if (isLabelDifferent) {
            return true
        }
        return false
    }

    componentDidUpdate = () => {
        this.chartConfig()
    }

    componentDidMount = () => {
        this.chartConfig()
    }

    chartConfig = () => {
        const chartConfig = {
            type: this.props.type,
            data: {
                labels: this.props.labels,
                datasets: this.props.dataSets,
            },
            options: {
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                },
            },
        }
        new Chart(this.canvasRef.current, chartConfig)
    }

    render() {
        return <canvas ref={this.canvasRef} />
    }
}
